<template>
  <div class="flex justify-center">
    <div v-if="showAssignToMe" class="w-full tablet:w-auto ">
      <vs-button
       class="w-full tablet:w-auto"
        @click="handleAssignToMeClick"
      >Assign to me</vs-button>
    </div>

    <div v-if="showUnassignMe"  class="w-full tablet:w-auto">
      <vs-button
        class="w-full tablet:w-auto"
        @click="handleUnassignMeClick"
      >Unassign me</vs-button>
    </div>

    <div v-if="showAssignToOther" class="ml-2 w-full tablet:w-auto" >
      <vs-button
        class="w-full tablet:w-auto"
        @click="handleAssignToOtherClick"
      >Assign to other</vs-button>
    </div>

    <div v-if="showAssignDropdown" class="flex w-full tablet:w-auto">
      <vs-select
        autocomplete
        label="Assign to"
        v-model="selectedCaseworker"
      >
        <vs-select-item
          :placeholder="'Placeholder'"
          :key="'assign-caseworker-'+booking.id+'-'+index"
          :value="caseworker"
          :text="caseworker.displayName"
          v-for="(caseworker, index) in caseworkers"
          @click="handleAssignCaseworkerChange()"
        />
      </vs-select>
      <div class="ml-2 mt-6 flex">
      <vs-button :diabaled="!this.selectedCaseworker"
        @click="handleAssignClick" color="success" icon="done"
      ></vs-button>
      <vs-button class="ml-2"
        @click="handleCancelClick" color="danger" icon="close"
      ></vs-button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as BOOKING_ACTIONS } from "@/store/modules/marcom/marcom-booking";

export default {
  components: {},
  props: {
    booking: Object,
  },
  data() {
    return {
      selectedCaseworker: undefined,
      assignToOtherSelected: false,
    };
  },
  computed: {
    ...mapGetters({
      caseworkers: "marcomBooking/caseworkers",
      me: "users/me"
    }),
    isAssignedToMe() {
      return !!this.booking.caseworker && this.booking.caseworker.userId.id === this.me.userId;
    },
    showAssignToMe() {
      return !this.showAssignDropdown && !this.isAssignedToMe;
    },
    showUnassignMe() {
      return this.isAssignedToMe && !this.showAssignDropdown;
    },
    showAssignToOther() {
      return !this.assignToOtherSelected &&
        (!this.booking.caseworker || this.isAssignedToMe);
    },
    showAssignDropdown() {
      return this.assignToOtherSelected;
    }
  },
  mounted() {},
  methods: {
    async handleAssignToMeClick() {
      try {
        this.$vs.loading();

        await this.$store.dispatch(
          "marcomBooking/" + BOOKING_ACTIONS.AssignCurrentUserAsCaseworker,
          this.booking
        );

        this.$vs.notify({
          color: "success",
          title: "Booking assigned",
          text: "Booking assigned to user",
        });

        this.$emit("caseworker-assigned");
      }catch(err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Booking assigned",
          text: "Oops, something went wrong",
        });
      }finally{
        this.$vs.loading.close();
      }
    },
    async handleUnassignMeClick() {
      try {
        this.$vs.loading();

        await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.UnassignCurrentUserAsCaseworker,
        this.booking
      );

        this.$vs.notify({
          color: "success",
          title: "Booking unassigned",
          text: "Booking unassigned",
        });

        this.$emit("caseworker-assigned");
      }catch(err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Booking unassigned",
          text: "Oops, something went wrong",
        });
      }finally{
        this.$vs.loading.close();
      }
    },
    handleAssignToOtherClick() {
      this.assignToOtherSelected = true;
    },
    async handleAssignClick() {
      try {
        this.$vs.loading();

        await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.AssignUserAsCaseworker,
          {
            booking: this.booking,
            userId: this.selectedCaseworker.userId,
          }
        );

        this.$vs.notify({
          color: "success",
          title: "Booking unassigned",
          text: "Booking unassigned",
        });

        this.$emit("caseworker-assigned");
      }catch(err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Booking unassigned",
          text: "Oops, something went wrong",
        });
      }finally{
        this.$vs.loading.close();
      }
    },
    handleCancelClick() {
      this.assignToOtherSelected = false;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
